export default "table {\n  border-collapse: collapse;\n}\n\ntable, th, td {\n  border: 1px solid black;\n}";